import { useState } from 'react';
import { Lancamento } from '../services/types';

export const useObraModals = () => {
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isValoresCorrigidosModalOpen, setIsValoresCorrigidosModalOpen] = useState(false);
    const [isLancamentoEditModalOpen, setIsLancamentoEditModalOpen] = useState(false);
    const [isAttachmentsModalOpen, setIsAttachmentsModalOpen] = useState(false);

    const [selectedAttachments, setSelectedAttachments] = useState<any[]>([]);
    const [lancamentoToEdit, setLancamentoToEdit] = useState<Lancamento | null>(null);
    const [lancamentoEditInitialStep, setLancamentoEditInitialStep] = useState<number>(0);
    const [snackbarMessage, setSnackbarMessage] = useState<string | null>(null);

    const openAttachments = (anexos: any[]) => {
        setSelectedAttachments(anexos);
        setIsAttachmentsModalOpen(true);
    };

    const openLancamentoEdit = (lancamento: Lancamento | null, initialStep: number = 0) => {
        setLancamentoToEdit(lancamento);
        setLancamentoEditInitialStep(initialStep);
        setIsLancamentoEditModalOpen(true);
    };

    return {
        isEditModalOpen, setIsEditModalOpen,
        isDeleteModalOpen, setIsDeleteModalOpen,
        isValoresCorrigidosModalOpen, setIsValoresCorrigidosModalOpen,
        isLancamentoEditModalOpen, setIsLancamentoEditModalOpen,
        isAttachmentsModalOpen, setIsAttachmentsModalOpen,
        selectedAttachments, setSelectedAttachments,
        lancamentoToEdit, setLancamentoToEdit,
        lancamentoEditInitialStep, setLancamentoEditInitialStep,
        snackbarMessage, setSnackbarMessage,
        openAttachments,
        openLancamentoEdit
    };
};
